// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import App from './App'
import router from './router'
import 'lib-flexible/flexible'
import axios from 'axios';
import jsonpAdapter from 'axios-jsonp'
import VueJsonp from 'vue-jsonp'
import common from "./common";
import qs from 'qs';
import store from './store'//引入store
import BMap from 'vue-baidu-map'
//解决低版本安卓手机兼容性问题
import 'babel-polyfill'
import Es6Promise from 'es6-promise'
require('es6-promise').polyfill()
Es6Promise.polyfill()
import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);
//系统错误捕获
//const errorHandler = (error, vm)=>{
  //alert(error);
  //console.log(error);
//}
//Vue.config.errorHandler = errorHandler;
//Vue.prototype.$throw = (error)=> errorHandler(error,this);

Vue.use(MintUI)
// Vue.use(axios)
// Vue.use(jsonpAdapter)
Vue.use(VueJsonp)
Vue.config.productionTip = false
Vue.prototype.$api = axios.create({
  baseURL: 'https://api.xile.baiduwebs.top',
  //baseURL: 'http://api.xile.local.com/',
  timeout: 100000,
  headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'}
});
// axios.defaults.withCredentials = true;
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js